// extracted by mini-css-extract-plugin
module.exports = {"title":"legal-module--title--3suK9","heroWrapper":"legal-module--heroWrapper--1WKtL","heroGraphic":"legal-module--heroGraphic--11Snl"};